module.exports = __webpack_public_path__ + "static/media/vermi_environment.d26a258a.png";